export default "__VITE_ASSET__Dc5A$Pr3__"